import IconCore from './assets/icon_core.svg';
import IconValueAdd from './assets/icon_valadd.svg';
import IconOpportunistic from './assets/icon_opportunistic.svg';


const investmentStrategiesData = [
  {
    label: 'CORE',
    image: IconCore,
    blurb: 'Properties that are stable, fully leased, well-located and typically Class A. Lower risk for lower reward, with nonexistent or low leverage.',
  },
  {
    label: 'VALUE-ADD',
    image: IconValueAdd,
    blurb: 'Lower occupancy or secondary market locations with an opportunity to increase value through renovations or repositioning. Medium risk & reward with low to medium leverage.',
  },
  {
    label: 'OPPORTUNISTIC',
    image: IconOpportunistic,
    blurb: 'Typically raw land or ground-up development with little to no near term cash flow. High risk & high reward with high leverage.',
  },
];

export default investmentStrategiesData;
